<template>
      
  <!--[웹접근성] 바로가기 메뉴-->
  <ul id="skip_nav">
    <li><a href="#header"><h2>주메뉴 바로가기</h2></a></li>
    <li><a href="#container"><h2>본문 바로가기</h2></a></li>
    <li><a href="#footer"><h2>하단 바로가기</h2></a></li>
  </ul>
  <!--// [웹접근성] 바로가기 메뉴-->

  <div v-if="!isMainCssReady" class="layout-loading" role="status" aria-live="polite">
    <div class="layout-loading__spinner"></div>
  </div>

  <Header
      v-if="isMainCssReady"
      :menus="topMenus"
      :selected-menu-id="selectedMenuId"
      :is-logged-in="isLoggedIn"
      @menu-change="handleMenuChange"
      @login="isLoggedIn = true"
      @logout="isLoggedIn = false"
  />
  
  <!-- 모바일 메뉴 -->
  <MobileMenu
    v-if="isMainCssReady"
    :menus="allMenusTree"
    :selected-menu-id="selectedMenuId"
    :is-logged-in="isLoggedIn"
    @menu-change="handleMenuChange"
    @logout="isLoggedIn = false"
  />
  <div id="container">

    <!-- Content -->
    <div v-if="isMainCssReady" id="content" class="cont_main">
      <slot/>
    </div>

  </div>
  <FloatingMenu v-if="isMainCssReady"/>
  <Footer v-if="isMainCssReady"/>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import {FloatingMenu, Footer, Header, MobileMenu} from '@/components/layout'
import {useApiMenu} from '@/composables/useApiMenu.js'
import {provideMenuContext} from '@/composables/useMenuContext.js'
import { useUserStore } from '@/store/user.store'
import mainCssHref from '@/assets/css/main.css?url'

defineOptions({name: 'MainLayout'})

const userStore = useUserStore()

provideMenuContext()

const APP_NAME = '대구통합예약시스템'
let mainCssLink = null
const isMainCssReady = ref(false)

const props = defineProps({
  initialLoggedIn: {type: Boolean, default: false},
})

// userStore에서 로그인 상태 가져오기
const isLoggedIn = computed(() => userStore.isLoggedIn)

const DOMAIN_ID = import.meta.env.VITE_DOMAIN_ID
const selectedMenuId = ref(null)

const { getRootMenus, getMenuTree } = useApiMenu()

const topMenus = computed(() => {
  return getMenuTree(DOMAIN_ID)
})

const allMenusTree = computed(() => {
  return getMenuTree(DOMAIN_ID)
})

const handleMenuChange = (menuId) => {
  selectedMenuId.value = menuId
}

onMounted(() => {
  document.title = APP_NAME

  const markReady = () => {
    isMainCssReady.value = true
  }

  const existing = document.getElementById('main-layout-css')
  if (existing) {
    mainCssLink = existing
    if (mainCssLink.sheet) {
      markReady()
    } else {
      mainCssLink.addEventListener('load', markReady, { once: true })
      mainCssLink.addEventListener('error', markReady, { once: true })
    }
    return
  }

  // main.css 동적으로 추가 (빌드 경로 대응)
  mainCssLink = document.createElement('link')
  mainCssLink.rel = 'stylesheet'
  mainCssLink.href = mainCssHref
  mainCssLink.id = 'main-layout-css'
  mainCssLink.addEventListener('load', markReady, { once: true })
  mainCssLink.addEventListener('error', markReady, { once: true })
  document.head.appendChild(mainCssLink)
})

onUnmounted(() => {
  if (mainCssLink && mainCssLink.parentNode) {
    mainCssLink.parentNode.removeChild(mainCssLink)
  }
  mainCssLink = null
})

</script>
<style scoped>
.layout-loading {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}

.layout-loading__spinner {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 4px solid #d9d9d9;
  border-top-color: #333;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
